module.exports = __webpack_public_path__ + "static/media/YM27_2.cf301297.jpg";